import Box from "@shared/components/ui-kit/layout/Box/Box.web";
import Flex from "@shared/components/ui-kit/layout/Flex/Flex.web";
import Text from "@shared/components/ui-kit/typography/Text/Text.web";

function SectionHeader({
  sectionNumber,
  title,
  subtitle,
  isValid,
  cta,
}: {
  sectionNumber: number;
  title: string;
  subtitle?: string;
  isValid: boolean;
  cta?: React.ReactNode;
}) {
  return (
    <Flex justifyContent="space-between" alignItems="center" mt="md" mb="md">
      <Box>
        <Flex gap="md" alignItems="center">
          <Flex
            borderRadius="50%"
            border="1px solid"
            borderColor={isValid ? "green.600" : "font.dark"}
            backgroundColor={isValid ? "green.600" : "transparent"}
            color={isValid ? "white" : "font.dark"}
            justifyContent="center"
            alignItems="center"
            width="element.lg"
            height="element.lg"
          >
            <Text fontSize="sm" marginBottom="1.5px">
              {sectionNumber}
            </Text>
          </Flex>
          <Box>
            <Text fontWeight={700}>{title}</Text>
            {subtitle && <Text fontSize="xs">{subtitle}</Text>}
          </Box>
        </Flex>
      </Box>

      {cta && <Box>{cta}</Box>}
    </Flex>
  );
}

export default SectionHeader;
